import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import shouldLoadDyna from "@/bit/core/core.utils.should-load-dyna";
import RouteHandler from "@/bit/core/core.route-handler";
import Saam from "@/bit/core/core.scripts.saam";
import OneTrust from "@/bit/components/components.one-trust-x";
const Dyna = dynamic(() => import("@/bit/core/core.scripts.dyna"));
import { wrapper } from "store";
import "@/styles/globals.scss";
import "@/styles/skeleton.scss";
import "@/styles/globalVars.scss";
// IMPORTS

 /* [STYLES] begins */ 
 import '@/styles/globals.scss'; 
 import '@/styles/grid.scss'; 
 import '@/styles/colors.scss'; 
 import '@/styles/fonts.scss';
 
 /* [STYLES] ends */ 

import '@/styles/calendar.scss';
import "@/components/comercial-area/comercial-card/styles.scss";


const App = ({ Component, pageProps, ...rest }) => {
  const Modal = useSelector((state) => state.modals.Modal);
  return (
    <>
      <RouteHandler isReactApp />
      <Component {...pageProps} />
      {Modal && Modal}
      <OneTrust />
      <Saam />
      {shouldLoadDyna() && <Dyna />}      
      {/* APP DELIMITER */}
    </>
  );
};

export default wrapper.withRedux(App);
